var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 465,
    viewBox: "0 0 256 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.613 1.12433H52.387C23.54 1.12433 0.154907 24.2595 0.154907 52.7981V413.144C0.154907 441.683 23.54 464.818 52.387 464.818H203.613C232.46 464.818 255.845 441.683 255.845 413.144V52.7981C255.845 24.2595 232.46 1.12433 203.613 1.12433Z",
    fill: "url(#paint0_linear_157_1042)",
    stroke: "url(#paint1_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5096 409.924C10.5096 421.764 15.2639 433.119 23.7266 441.492C32.1892 449.864 43.6671 454.567 55.6351 454.567H200.133C212.101 454.567 223.578 449.864 232.041 441.492C240.504 433.119 245.258 421.764 245.258 409.924V286.175C236.316 278.485 226.546 271.791 216.125 266.214C136.725 223.812 55.2724 267.499 21.7197 226.94C17.6751 222.034 12.5334 213.755 10.5623 200.068",
    fill: "url(#paint2_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7252 433.797H46.3899C42.6178 433.797 39.0002 432.315 36.333 429.676C33.6657 427.037 32.1673 423.458 32.1673 419.727L32.1673 171.274H99.7314L99.7314 433.797H99.7252Z",
    fill: "#151529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4556 427.598V404.859H70.4713V427.598H93.4556Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1857 398.656C88.3394 398.656 89.2746 397.731 89.2746 396.59C89.2746 395.448 88.3394 394.523 87.1857 394.523C86.032 394.523 85.0968 395.448 85.0968 396.59C85.0968 397.731 86.032 398.656 87.1857 398.656Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82 433.803H110.864V332.897C110.864 331.308 111.18 329.735 111.795 328.268C112.409 326.801 113.31 325.467 114.445 324.345C115.581 323.222 116.929 322.331 118.412 321.723C119.895 321.116 121.485 320.803 123.091 320.804H212.861C216.103 320.804 219.212 322.078 221.504 324.346C223.797 326.613 225.085 329.689 225.085 332.897V423.654C225.083 426.347 224.001 428.928 222.076 430.831C220.151 432.734 217.541 433.803 214.82 433.803Z",
    fill: "url(#paint3_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1857 395.9V268.434",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1857 396.59V274.634",
    stroke: "url(#paint4_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7411 395.9V330.1",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0596 417.262V351.459",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7411 398.656C77.8948 398.656 78.83 397.731 78.83 396.59C78.83 395.448 77.8948 394.523 76.7411 394.523C75.5875 394.523 74.6522 395.448 74.6522 396.59C74.6522 397.731 75.5875 398.656 76.7411 398.656Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6363 416.743H52.0151",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7855 329.929H64.5516",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3337 418.81C64.4873 418.81 65.4226 417.885 65.4226 416.743C65.4226 415.602 64.4873 414.677 63.3337 414.677C62.18 414.677 61.2448 415.602 61.2448 416.743C61.2448 417.885 62.18 418.81 63.3337 418.81Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9432 399.003L65.9432 259.821H40.8701L40.8701 399.003H65.9432Z",
    fill: "url(#paint5_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.624 309.082V266.364H110.867V309.082H237.624Z",
    fill: "#151529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.973 302.195V291.172H117.831V302.195H128.973Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16 302.195V291.172H133.018V302.195H144.16Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 236.693C20.8271 231.143 17.6782 224.704 17.6782 224.704C13.5806 217.105 11.1138 208.75 10.4321 200.163L10.5747 61.7051C10.4476 59.0897 9.75959 37.7462 26.8583 23.553C38.4248 13.9529 51.451 13.1649 55.7001 13.0883L200.108 13.1281C204.679 13.2232 216.68 14.097 227.691 22.6332C245.785 36.6577 245.41 59.1203 245.323 61.7051C245.311 148.547 245.297 235.389 245.283 322.232C242.971 317.06 237.844 306.715 228.568 296.722C173.928 237.898 69.6437 293.083 25.2001 236.693Z",
    fill: "url(#paint6_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5747 205.176V199.924C12.332 209.619 16.2743 223.585 26.3438 235.589C45.1161 257.972 74.2462 263.522 122.273 264.276C189.756 265.334 211.78 275.553 229.653 295.551C238.049 304.942 242.67 315.045 245.283 322.226V322.978C240.996 313.524 235.223 304.802 228.178 297.136C228.178 297.136 221.846 290.02 214.048 284.706C197.281 273.281 172.828 267.315 122.242 266.521C74.3454 265.769 43.6006 260.388 24.7539 237.04C15.8838 226.063 12.2545 213.703 10.5747 205.176Z",
    fill: "url(#paint7_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1857 397.623C87.7625 397.623 88.2301 397.16 88.2301 396.59C88.2301 396.019 87.7625 395.556 87.1857 395.556C86.6089 395.556 86.1412 396.019 86.1412 396.59C86.1412 397.16 86.6089 397.623 87.1857 397.623Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.791 297.667C150.368 297.667 150.835 297.204 150.835 296.633C150.835 296.063 150.368 295.6 149.791 295.6C149.214 295.6 148.747 296.063 148.747 296.633C148.747 297.204 149.214 297.667 149.791 297.667Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7411 397.623C77.3179 397.623 77.7856 397.16 77.7856 396.59C77.7856 396.019 77.3179 395.556 76.7411 395.556C76.1643 395.556 75.6967 396.019 75.6967 396.59C75.6967 397.16 76.1643 397.623 76.7411 397.623Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3336 417.777C63.9105 417.777 64.3781 417.314 64.3781 416.743C64.3781 416.173 63.9105 415.71 63.3336 415.71C62.7568 415.71 62.2892 416.173 62.2892 416.743C62.2892 417.314 62.7568 417.777 63.3336 417.777Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7411 396.59V329.929H65.9463",
    stroke: "url(#paint8_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.154 296.544H217.538V287.855",
    stroke: "url(#paint9_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0596 399V416.743H63.3337",
    stroke: "url(#paint10_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.043 424.878H119.57V339.366C119.57 336.642 120.664 334.029 122.611 332.103C124.558 330.177 127.199 329.095 129.953 329.095H205.996C208.75 329.095 211.391 330.177 213.338 332.103C215.285 334.029 216.379 336.642 216.379 339.366V411.675C216.381 413.409 216.038 415.126 215.369 416.728C214.7 418.331 213.718 419.787 212.479 421.013C211.24 422.239 209.769 423.212 208.15 423.875C206.531 424.538 204.795 424.879 203.043 424.878Z",
    stroke: "url(#paint11_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.257 80.5956H38.1396C36.0565 80.5956 34.3678 82.2662 34.3678 84.3271V98.2229C34.3678 100.284 36.0565 101.954 38.1396 101.954H218.257C220.34 101.954 222.029 100.284 222.029 98.2229V84.3271C222.029 82.2662 220.34 80.5956 218.257 80.5956Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.257 80.5956H38.1396C36.0565 80.5956 34.3678 82.2662 34.3678 84.3271V98.2229C34.3678 100.284 36.0565 101.954 38.1396 101.954H218.257C220.34 101.954 222.029 100.284 222.029 98.2229V84.3271C222.029 82.2662 220.34 80.5956 218.257 80.5956Z",
    stroke: "url(#paint12_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8569 96.4721C48.6161 96.4721 50.8529 94.218 50.8529 91.4375C50.8529 88.657 48.6161 86.4029 45.8569 86.4029C43.0976 86.4029 40.8608 88.657 40.8608 91.4375C40.8608 94.218 43.0976 96.4721 45.8569 96.4721Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.2846 56.1676C52.0546 56.1676 56.7322 51.54 56.7322 45.8316C56.7322 40.1232 52.0546 35.4956 46.2846 35.4956C40.5145 35.4956 35.8369 40.1232 35.8369 45.8316C35.8369 51.54 40.5145 56.1676 46.2846 56.1676Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2846 56.1676C52.0546 56.1676 56.7322 51.54 56.7322 45.8316C56.7322 40.1232 52.0546 35.4956 46.2846 35.4956C40.5145 35.4956 35.8369 40.1232 35.8369 45.8316C35.8369 51.54 40.5145 56.1676 46.2846 56.1676Z",
    stroke: "url(#paint13_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6212 47.6529H45.6771C46.0786 47.6533 46.4763 47.5754 46.8475 47.4236C47.2186 47.2719 47.5558 47.0493 47.8399 46.7685C48.124 46.4877 48.3493 46.1543 48.5031 45.7873C48.6569 45.4203 48.7361 45.0269 48.7361 44.6297C48.7361 44.2324 48.6569 43.839 48.5031 43.472C48.3493 43.105 48.124 42.7716 47.8399 42.4908C47.5558 42.2101 47.2186 41.9874 46.8475 41.8357C46.4763 41.6839 46.0786 41.606 45.6771 41.6064C44.8666 41.6064 44.0894 41.925 43.5163 42.4919C42.9432 43.0589 42.6212 43.8279 42.6212 44.6297V47.6529Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.171 49.0756H47.2608C46.4893 49.0748 45.7495 48.7712 45.2039 48.2314C44.6583 47.6917 44.3514 46.9598 44.3506 46.1965C44.3506 45.4329 44.6572 44.7006 45.203 44.1607C45.7487 43.6207 46.489 43.3174 47.2608 43.3174C47.6431 43.317 48.0218 43.3912 48.375 43.5357C48.7283 43.6803 49.0492 43.8923 49.3196 44.1598C49.5899 44.4272 49.8042 44.7447 49.9503 45.0942C50.0964 45.4437 50.1714 45.8183 50.171 46.1965V49.0756Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.728 56.1676C215.498 56.1676 220.175 51.54 220.175 45.8316C220.175 40.1232 215.498 35.4956 209.728 35.4956C203.958 35.4956 199.28 40.1232 199.28 45.8316C199.28 51.54 203.958 56.1676 209.728 56.1676Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.728 56.1676C215.498 56.1676 220.175 51.54 220.175 45.8316C220.175 40.1232 215.498 35.4956 209.728 35.4956C203.958 35.4956 199.28 40.1232 199.28 45.8316C199.28 51.54 203.958 56.1676 209.728 56.1676Z",
    stroke: "url(#paint14_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.409 50.0813H209.684C210.551 50.0813 211.382 49.742 211.995 49.1375C212.609 48.533 212.956 47.7126 212.96 46.8557C212.96 45.9959 212.615 45.1713 212.001 44.563C211.387 43.9547 210.554 43.6126 209.684 43.6118C208.815 43.6126 207.982 43.9547 207.368 44.563C206.754 45.1713 206.409 45.9959 206.409 46.8557V50.0813Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.712 43.4431C210.736 43.4431 211.566 42.6222 211.566 41.6096C211.566 40.5969 210.736 39.776 209.712 39.776C208.689 39.776 207.859 40.5969 207.859 41.6096C207.859 42.6222 208.689 43.4431 209.712 43.4431Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.476 111.947H38.9176C36.8345 111.947 35.1458 113.618 35.1458 115.678V174.361C35.1458 176.422 36.8345 178.093 38.9176 178.093H217.476C219.559 178.093 221.248 176.422 221.248 174.361V115.678C221.248 113.618 219.559 111.947 217.476 111.947Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.476 111.947H38.9176C36.8345 111.947 35.1458 113.618 35.1458 115.678V174.361C35.1458 176.422 36.8345 178.093 38.9176 178.093H217.476C219.559 178.093 221.248 176.422 221.248 174.361V115.678C221.248 113.618 219.559 111.947 217.476 111.947Z",
    stroke: "url(#paint15_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5854 156.734H44.552C42.8404 156.734 41.4528 158.107 41.4528 159.8V167.447C41.4528 169.141 42.8404 170.513 44.552 170.513H87.5854C89.2971 170.513 90.6847 169.141 90.6847 167.447V159.8C90.6847 158.107 89.2971 156.734 87.5854 156.734Z",
    fill: "#170D5B"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M139.576 141.919H41.7937V148.118H139.576V141.919Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M122.48 131.586H41.7937V137.785H122.48V131.586Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M142.312 120.56H41.7937V126.76H142.312V120.56Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.495 186.819H38.899C36.8159 186.819 35.1272 188.49 35.1272 190.551V219.228C35.1272 221.289 36.8159 222.96 38.899 222.96H217.495C219.578 222.96 221.266 221.289 221.266 219.228V190.551C221.266 188.49 219.578 186.819 217.495 186.819Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.495 186.819H38.899C36.8159 186.819 35.1272 188.49 35.1272 190.551V219.228C35.1272 221.289 36.8159 222.96 38.899 222.96H217.495C219.578 222.96 221.266 221.289 221.266 219.228V190.551C221.266 188.49 219.578 186.819 217.495 186.819Z",
    stroke: "url(#paint16_linear_157_1042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M178.961 194.42H43.1357V202.647H178.961V194.42Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M149.828 205.458H43.1357V213.685H149.828V205.458Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M144.395 377.5C149.318 377.5 153.309 373.552 153.309 368.682C153.309 363.811 149.318 359.863 144.395 359.863C139.472 359.863 135.482 363.811 135.482 368.682C135.482 373.552 139.472 377.5 144.395 377.5Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.492 395.688H165.067C164.465 395.688 163.886 395.451 163.46 395.03C163.033 394.609 162.793 394.037 162.792 393.441V393.223C162.792 392.624 163.033 392.049 163.461 391.625C163.89 391.201 164.471 390.963 165.077 390.963H174.52C182.082 390.963 188.396 385.021 188.51 377.54C188.537 375.732 188.2 373.937 187.52 372.259C186.84 370.581 185.829 369.054 184.547 367.766C183.265 366.478 181.737 365.454 180.052 364.755C178.367 364.056 176.558 363.695 174.731 363.693H165.356C164.742 363.692 164.153 363.451 163.719 363.021C163.285 362.592 163.041 362.01 163.04 361.403V358.965H174.731C177.182 358.97 179.609 359.454 181.87 360.39C184.132 361.326 186.184 362.695 187.909 364.418C189.634 366.142 190.997 368.185 191.92 370.432C192.844 372.679 193.309 375.084 193.289 377.509C193.19 387.618 184.711 395.688 174.492 395.688Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.646 378.993H154.387C153.754 378.992 153.147 378.743 152.7 378.3C152.252 377.856 152.001 377.255 152.001 376.629C152.001 376.319 152.063 376.012 152.183 375.726C152.302 375.439 152.478 375.179 152.7 374.96C152.921 374.74 153.185 374.566 153.474 374.448C153.764 374.329 154.074 374.268 154.387 374.268H165.256C165.89 374.268 166.497 374.517 166.945 374.959C167.393 375.402 167.645 376.003 167.646 376.629V378.993Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.341 387.425H159.197C158.564 387.425 157.956 387.176 157.508 386.733C157.059 386.289 156.808 385.688 156.808 385.061C156.808 384.434 157.059 383.833 157.508 383.389C157.956 382.946 158.564 382.697 159.197 382.697H169.946C170.579 382.697 171.187 382.946 171.635 383.389C172.083 383.833 172.335 384.434 172.335 385.061L172.341 387.425Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.124 370.981H144.299C143.662 370.991 143.046 370.754 142.583 370.321C142.119 369.888 141.845 369.293 141.82 368.663C141.814 368.349 141.872 368.037 141.99 367.746C142.107 367.454 142.283 367.189 142.505 366.965C142.727 366.741 142.993 366.563 143.285 366.441C143.578 366.319 143.892 366.257 144.209 366.256H160.747C161.38 366.256 161.987 366.505 162.434 366.948C162.882 367.39 163.133 367.991 163.133 368.617L163.124 370.981Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M144.299 371.561C143.511 371.567 142.752 371.269 142.183 370.73C141.613 370.191 141.278 369.454 141.249 368.675C141.242 368.285 141.313 367.897 141.459 367.534C141.605 367.172 141.823 366.841 142.099 366.563C142.376 366.284 142.705 366.063 143.069 365.912C143.433 365.761 143.824 365.683 144.219 365.683H149.227C148.565 364.641 147.578 363.842 146.415 363.407C145.252 362.972 143.977 362.925 142.784 363.274C141.591 363.622 140.547 364.346 139.809 365.336C139.071 366.326 138.68 367.528 138.696 368.758C138.713 369.988 139.135 371.179 139.898 372.15C140.662 373.121 141.726 373.818 142.927 374.135C144.129 374.453 145.402 374.373 146.553 373.908C147.704 373.443 148.671 372.619 149.304 371.561H144.299Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.888 65.5285C138.828 65.5285 147.696 56.7552 147.696 45.9328C147.696 35.1103 138.828 26.337 127.888 26.337C116.949 26.337 108.081 35.1103 108.081 45.9328C108.081 56.7552 116.949 65.5285 127.888 65.5285Z",
    fill: "url(#paint17_linear_157_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7186 420.4L77.1963 420.956L77.7568 418.454C77.3991 417.791 77.1963 417.033 77.1963 416.228C77.1963 413.617 79.3306 411.501 81.9634 411.501C84.5962 411.501 86.7305 413.617 86.7305 416.228C86.7305 418.839 84.5962 420.956 81.9634 420.956C81.1518 420.956 80.3876 420.755 79.7186 420.4Z",
    fill: "#ABA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.516 51.0509L129.399 53.7047L127.281 51.0509H123.349C122.931 51.0509 122.593 50.7114 122.593 50.2927V42.0298C122.593 41.6111 122.931 41.2716 123.349 41.2716H135.448C135.866 41.2716 136.205 41.6111 136.205 42.0298V50.2927C136.205 50.7114 135.866 51.0509 135.448 51.0509H131.516ZM120.324 38.1609H133.18V39.6774H121.08V48.018H119.568V38.9191C119.568 38.5004 119.906 38.1609 120.324 38.1609Z",
    fill: "#D8D5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_1042",
    x1: 272.476,
    y1: -19.5108,
    x2: 10.0572,
    y2: 449.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBEB",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CDCFE6",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C6C7E2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_157_1042",
    x1: 128,
    y1: 0.971021,
    x2: 128,
    y2: 464.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_157_1042",
    x1: 127.727,
    y1: 304.363,
    x2: 128.282,
    y2: 461.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#242441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2F2F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#36365F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#373761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#323259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2A2A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1F1F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_157_1042",
    x1: 220.681,
    y1: 441.923,
    x2: 97.7346,
    y2: 296.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#242243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2D2B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#383669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#43427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_157_1042",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_157_1042",
    x1: 50.8374,
    y1: 379.149,
    x2: 57.047,
    y2: 256.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E2E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_157_1042",
    x1: 27.0814,
    y1: 6.37646,
    x2: 301.508,
    y2: 351.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D6D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CED1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C1C4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEB1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9B9EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_157_1042",
    x1: 271.729,
    y1: 328.809,
    x2: 24.1987,
    y2: 219.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D8DBEB",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D9DCEC",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DBDEED",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#DEE1EE",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E2E4F0",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E7E8F2",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ECEEF5",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2F3F9",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F9FAFC",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_157_1042",
    x1: 71.4196,
    y1: 329.775,
    x2: 71.4196,
    y2: 396.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_157_1042",
    x1: 217.69,
    y1: 292.276,
    x2: 150.154,
    y2: 292.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_157_1042",
    x1: 58.1207,
    y1: 399.003,
    x2: 58.1207,
    y2: 416.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_157_1042",
    x1: 167.974,
    y1: 424.875,
    x2: 167.974,
    y2: 329.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5C5CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7A78C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#928EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A39EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ADA7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_157_1042",
    x1: 128.198,
    y1: 80.5956,
    x2: 128.198,
    y2: 101.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_157_1042",
    x1: 52.6385,
    y1: 37.3857,
    x2: 40.2761,
    y2: 54.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_157_1042",
    x1: 216.082,
    y1: 37.376,
    x2: 203.72,
    y2: 54.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_157_1042",
    x1: 128.198,
    y1: 111.947,
    x2: 128.198,
    y2: 178.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_157_1042",
    x1: 128.198,
    y1: 186.819,
    x2: 128.198,
    y2: 222.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_157_1042",
    x1: 108.081,
    y1: 45.9328,
    x2: 147.696,
    y2: 45.9328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#35355E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D2D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1F1F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 464,
    fill: "white",
    transform: "translate(0 0.970825)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseSms);
export default __webpack_public_path__ + "static/media/Enterprise-SMS.0431aae13bd74374d91f97c80d36a085.svg";
export { ForwardRef as ReactComponent };